export default {
  install (Vue) {
    Vue.mixin({
      beforeCreate () {
        if (this.$options.handlers) {
          this.$options.methods = Object.assign(this.$options.methods || {}, this.$options.handlers)
        }
      }
    })
  }
}
